import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-complete-guide",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-template",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-review",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-tutorial",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-download",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-alternative",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparison",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-safety",
    element: <Article />,
  },
  {
    path: "/vigorbuy-spreadsheet-features",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;